<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header liga-float-header" :class="{ 'page-header--scrolled': headerScrolled }">
      <ion-toolbar class="event-detail-float-toolbar">
        <div class="liga-float-bar">
          <button type="button" class="liga-float-circle" aria-label="Назад" @click="$router.push('/events')">
            <IonIcon :icon="chevronBackOutline" />
          </button>
          <div class="liga-float-title-pill">
            <span class="liga-float-title-text">Событие</span>
          </div>
          <button
            v-if="event && isAdmin"
            type="button"
            class="liga-float-circle"
            aria-label="Редактировать"
            @click="$router.push(`/admin-events/${event.id}/edit`)"
          >
            <IonIcon :icon="createOutline" />
          </button>
          <button
            v-if="event && isAdmin"
            type="button"
            class="liga-float-circle"
            aria-label="Участники"
            @click="$router.push(`/admin-events/${event.id}/registrations`)"
          >
            <IonIcon :icon="peopleOutline" />
          </button>
          <div v-if="!(event && isAdmin)" class="liga-float-spacer" aria-hidden="true" />
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background events-content" :fullscreen="true" @ionScroll="onContentScroll">
      <div v-if="loading" class="ion-padding ion-text-center">Загрузка...</div>
      <div v-else-if="!event" class="ion-padding ion-text-center">Событие не найдено.</div>
      <div v-else class="ion-padding event-detail">
        <img
          :src="event.logoPath ? eventsService.logoUrl(event.logoPath) : defaultEventLogo"
          class="event-detail-logo"
          :alt="event.title"
        />
        <h1 class="event-detail-title">{{ event.title }}</h1>
        <p v-if="event.startAt" class="event-detail-meta">{{ formatDate(event.startAt) }}</p>
        <p v-if="event.location" class="event-detail-location">{{ event.location }}</p>
        <template v-if="event.description">
          <p class="event-detail-desc-label">Программа / Описание</p>
          <p class="event-detail-desc">{{ event.description }}</p>
        </template>
        <div v-if="event.isPaid && event.priceTiers?.length" class="event-tiers">
          <p class="tiers-label">Тарифы:</p>
          <ul>
            <li v-for="t in event.priceTiers" :key="t.id">{{ t.name }} — {{ (t.amountKopecks / 100).toFixed(0) }} ₽</li>
          </ul>
        </div>

        <template v-if="!myReg && canRegister">
          <ion-item v-if="event.isPaid" lines="none" class="event-phone-item">
            <ion-input
              v-model="paymentPhone"
              type="tel"
              inputmode="tel"
              autocomplete="tel"
              name="phone"
              label="Телефон"
              label-placement="stacked"
              placeholder="+7 ___ ___-__-__"
              @ionInput="onPaymentPhoneInput"
              @ionBlur="onPaymentPhoneBlur"
            />
          </ion-item>
          <ion-note v-if="event.isPaid" class="event-phone-note">
            Телефон обязателен для платной регистрации и нужен для связи после покупки.
          </ion-note>
          <ion-button expand="block" class="event-register-btn" :disabled="registering || phoneRequiredMissing" @click="register">
            Записаться
          </ion-button>
          <ion-item v-if="event.isPaid && event.priceTiers?.length" lines="none">
            <ion-select
              label="Тариф"
              cancel-text="Отмена"
              v-model="selectedTierId"
              interface="action-sheet"
              :interface-options="{ header: 'Выберите тариф', cssClass: 'liga-glass-action-sheet' }"
              placeholder="Выберите"
            >
              <ion-select-option v-for="t in event.priceTiers" :key="t.id" :value="t.id">{{ t.name }} — {{ (t.amountKopecks / 100).toFixed(0) }} ₽</ion-select-option>
            </ion-select>
          </ion-item>
        </template>
        <ion-note v-else-if="!myReg && !canRegister" class="reg-status">Регистрация закрыта</ion-note>

        <template v-else>
          <ion-note class="reg-status">Вы записаны{{ event.isPaid && !myReg.paid && canRegister ? '. Оплатите участие.' : '' }}</ion-note>
          <ion-item
            v-if="showPayButton && event.priceTiers && event.priceTiers.length >= 2"
            lines="none"
            class="event-tier-select-item"
          >
            <ion-select
              label="Тариф"
              cancel-text="Отмена"
              v-model="selectedTierIdForPay"
              interface="action-sheet"
              :interface-options="{ header: 'Выберите тариф', cssClass: 'liga-glass-action-sheet' }"
              placeholder="Выберите тариф"
            >
              <ion-select-option v-for="t in event.priceTiers" :key="t.id" :value="t.id">
                {{ t.name }} — {{ (t.amountKopecks / 100).toFixed(0) }} ₽
              </ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item v-if="showPayButton" lines="none" class="event-phone-item">
            <ion-input
              v-model="paymentPhone"
              type="tel"
              inputmode="tel"
              autocomplete="tel"
              name="phone"
              label="Телефон"
              label-placement="stacked"
              placeholder="+7 ___ ___-__-__"
              @ionInput="onPaymentPhoneInput"
              @ionBlur="onPaymentPhoneBlur"
            />
          </ion-item>
          <ion-note v-if="showPayButton" class="event-phone-note">
            Телефон обязателен для оплаты и нужен для связи после покупки.
          </ion-note>
          <ion-button
            v-if="showPayButton"
            expand="block"
            class="event-pay-btn"
            :disabled="paying || phoneRequiredMissing"
            @click="goPay"
          >
            Оплатить {{ (amountToPayKopecks / 100).toFixed(0) }} ₽
          </ion-button>
          <ion-note v-if="showPayButton" class="offer-note">
            Нажимая «Оплатить», вы соглашаетесь с
            <router-link to="/offer-supplement">договором оферты и дополнением о платных событиях</router-link>.
          </ion-note>
          <p v-if="showPayButton" class="event-refund-note">
            Условия возврата средств: см. <router-link to="/offer-supplement">Дополнение к оферте</router-link>.
          </p>
          <div class="qr-block" v-if="myReg">
            <p class="qr-label">QR-код для входа</p>
            <div class="qr-wrap qr-liga-style">
              <qrcode-vue :value="qrPayload" :size="200" level="M" :margin="1" :options="qrOptions" />
            </div>
          </div>
          <ion-button
            v-if="eventNotStarted"
            expand="block"
            fill="outline"
            color="warning"
            class="event-cancel-btn"
            :disabled="cancelling"
            @click="confirmCancelRegistration"
          >
            Отменить участие
          </ion-button>
        </template>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonNote,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonToolbar
} from '@ionic/vue';
import { alertController, toastController } from '@ionic/vue';
import { chevronBackOutline, createOutline, peopleOutline } from 'ionicons/icons';
import { defineComponent, inject } from 'vue';
import { useRoute } from 'vue-router';
import { ILigaEvent } from '@/model/liga-event.model';
import { ILigaEventRegistration } from '@/model/liga-event-registration.model';
import { GlobalContext } from '@/model/globalcontext.model';
import eventsService from '@/services/events.service';
import { formatPhoneDisplay, isValidPhone, phoneForApi } from '@/utils/phone.util';
import dayjs from 'dayjs';
import QrcodeVue from 'qrcode.vue';

export default defineComponent({
  name: 'EventDetail',
  components: {
    IonButton,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonNote,
    IonPage,
    IonSelect,
    IonSelectOption,
    IonToolbar,
    QrcodeVue
  },
  setup() {
    const route = useRoute();
    const accountService = inject<{ hasAnyAuthorityAndCheckAuth: (auth: string) => Promise<boolean> }>('accountService');
    const globalContext = inject('globalContext') as GlobalContext;
    return { route, accountService, globalContext, chevronBackOutline, createOutline, peopleOutline };
  },
  data() {
    return {
      event: null as ILigaEvent | null,
      myReg: null as ILigaEventRegistration | null,
      loading: true,
      registering: false,
      paying: false,
      cancelling: false,
      selectedTierId: null as number | null,
      /** Выбранный тариф для оплаты (когда уже записан и тарифов несколько). */
      selectedTierIdForPay: null as number | null,
      paymentPhone: '',
      headerScrolled: false,
      isAdmin: false,
      eventsService,
      defaultEventLogo: require('@/theme/liga-logo-white.png'),
      qrOptions: { colorDark: '#ff6600', colorLight: '#1a1a1a' }
    };
  },
  computed: {
    qrPayload(): string {
      if (!this.myReg || !this.event) return '';
      return `${this.event.id}:${this.myReg.id}`;
    },
    eventNotStarted(): boolean {
      // Без даты — считаем, что ещё не началось (отмена разрешена)
      if (!this.event?.startAt) return true;
      return dayjs(this.event.startAt).isAfter(dayjs());
    },
    /** Можно записаться: бессрочные или ещё не начавшиеся. */
    canRegister(): boolean {
      return this.eventNotStarted;
    },
    /** Сумма к оплате: из регистрации, из выбранного тарифа для оплаты (при 2+ тарифах) или единственного тарифа. */
    amountToPayKopecks(): number {
      if (!this.myReg || !this.event?.priceTiers?.length) return 0;
      if (this.myReg.amountPaidKopecks != null && this.myReg.amountPaidKopecks > 0) return this.myReg.amountPaidKopecks;
      const tierId = this.selectedTierIdForPay ?? this.myReg.priceTierId;
      if (tierId != null) {
        const tier = this.event.priceTiers.find((t) => t.id === tierId);
        if (tier) return tier.amountKopecks;
      }
      if (this.event.priceTiers.length === 1) return this.event.priceTiers[0].amountKopecks;
      return 0;
    },
    showPayButton(): boolean {
      return Boolean(
        this.event?.isPaid && this.myReg && !this.myReg.paid && this.amountToPayKopecks > 0 && this.canRegister
      );
    },
    phoneRequiredMissing(): boolean {
      return Boolean(this.event?.isPaid && !isValidPhone(this.paymentPhone));
    },
    normalizedPaymentPhone(): string {
      return phoneForApi(this.paymentPhone);
    }
  },
  async mounted() {
    const ok =
      (await this.accountService?.hasAnyAuthorityAndCheckAuth?.('ROLE_ADMIN')) ||
      (await this.accountService?.hasAnyAuthorityAndCheckAuth?.('ROLE_MANAGER')) ||
      false;
    this.isAdmin = ok;
    await this.loadEventData(false);
  },
  ionViewWillEnter() {
    const id = Number(this.route.params.id);
    if (id && this.event?.id === id) {
      this.loadEventData(true);
    }
  },
  methods: {
    async loadEventData(silent = false) {
      const id = Number(this.route.params.id);
      if (!id) {
        this.loading = false;
        return;
      }
      if (!silent) this.loading = true;
      try {
        this.event = await eventsService.getEvent(id);
        const list = await eventsService.getMyRegistrations();
        this.myReg = list.find((r: ILigaEventRegistration) => r.ligaEventId === id) || null;
        if (this.event?.isPaid && this.event.priceTiers?.length === 1) {
          this.selectedTierId = this.event.priceTiers[0].id;
        }
        if (this.myReg?.priceTierId != null) {
          this.selectedTierIdForPay = this.myReg.priceTierId;
        }
        if (this.event?.isPaid && !isValidPhone(this.paymentPhone)) {
          try {
            const savedPhone = await eventsService.getMyEventPhone();
            this.paymentPhone = savedPhone ? formatPhoneDisplay(savedPhone) : '';
          } catch {
            this.paymentPhone = '';
          }
        }
      } catch (e) {
        if (!silent) this.event = null;
      }
      if (!silent) this.loading = false;
    },
    onContentScroll(e: CustomEvent) {
      const scrollTop = e.detail?.scrollTop ?? 0;
      this.headerScrolled = scrollTop > 16;
    },
    formatDate(iso: string | null | undefined) {
      if (!iso) return '';
      return dayjs(iso).format('D MMMM YYYY, HH:mm');
    },
    onPaymentPhoneInput(ev: CustomEvent) {
      const raw = (ev.detail as { value?: string })?.value ?? '';
      // Autofill браузера/телефона часто подставляет полный номер одним событием.
      if (isValidPhone(raw)) {
        this.paymentPhone = formatPhoneDisplay(raw);
        return;
      }
      this.paymentPhone = raw;
    },
    onPaymentPhoneBlur(ev: CustomEvent) {
      const raw = (ev.detail as { value?: string })?.value ?? this.paymentPhone;
      const formatted = formatPhoneDisplay(raw);
      if (formatted) {
        this.paymentPhone = formatted;
      }
    },
    async register() {
      if (!this.event) return;
      if (!this.canRegister) {
        await this.showPaymentErrorToast('Регистрация на прошедшее событие закрыта.');
        return;
      }
      if (this.event.isPaid && !isValidPhone(this.paymentPhone)) {
        await this.showPaymentErrorToast('Укажите корректный телефон для связи после покупки.');
        return;
      }
      this.registering = true;
      try {
        this.myReg = await eventsService.register(
          this.event.id,
          this.selectedTierId ?? undefined,
          this.normalizedPaymentPhone
        );
      } catch (e: any) {
        console.error(e);
        const errData = e?.response?.data ?? e?.data;
        const msg =
          errData?.errorKey === 'registration_limit_reached'
            ? 'Достигнут лимит регистраций на это событие.'
            : errData?.message || 'Не удалось записаться';
        const toast = await toastController.create({ message: msg, color: 'warning', duration: 4000 });
        await toast.present();
      }
      this.registering = false;
    },
    isValidEmail(s: string | null | undefined): boolean {
      if (s == null || typeof s !== 'string') return false;
      const t = s.trim();
      const at = t.indexOf('@');
      return at > 0 && at < t.length - 1 && t.indexOf('.', at + 1) > at + 1;
    },
    async goPay() {
      if (!this.myReg) return;
      if (this.phoneRequiredMissing) {
        await this.showPaymentErrorToast('Укажите корректный телефон для связи после покупки.');
        return;
      }
      const userEmail = this.myReg.userEmail?.trim();
      if (!this.isValidEmail(userEmail)) {
        const alert = await alertController.create({
          header: 'Email для чека',
          message: 'Укажите электронную почту, на которую будет направлен чек после оплаты.',
          inputs: [
            { name: 'email', type: 'email', placeholder: 'example@mail.ru', attributes: { required: true } }
          ],
          cssClass: 'liga-email-receipt-alert',
          buttons: [
            { text: 'Отмена', role: 'cancel' },
            {
              text: 'Оплатить',
              handler: (data) => {
                const entered = data?.email?.trim();
                if (!this.isValidEmail(entered)) {
                  this.showPaymentErrorToast('Укажите корректный email для чека.');
                  return false;
                }
                this.doPayment(entered);
                return true;
              }
            }
          ]
        });
        await alert.present();
        return;
      }
      const toast = await toastController.create({
        message: `Чек будет направлен на ${userEmail}`,
        color: 'primary',
        duration: 3000
      });
      await toast.present();
      await this.doPayment(userEmail);
    },
    async doPayment(customerEmail?: string) {
      if (!this.myReg) return;
      this.paying = true;
      try {
        const tierId = this.selectedTierIdForPay ?? this.myReg.priceTierId ?? undefined;
        const { redirectUrl } = await eventsService.createPayment(
          this.myReg.id,
          tierId,
          customerEmail,
          this.normalizedPaymentPhone
        );
        if (redirectUrl) {
          if (this.globalContext.isMobile) {
            window.open(redirectUrl, '_system');
          } else {
            window.location.href = redirectUrl;
          }
        }
      } catch (e: any) {
        console.error(e);
        const data = e?.response?.data;
        let msg =
          data?.detail ||
          (typeof data?.message === 'string' && !data.message.startsWith('error.') ? data.message : null) ||
          e?.message ||
          'Ошибка оплаты';
        if (
          data?.message === 'error.payment_unavailable' ||
          msg === 'Payment provider unavailable' ||
          e?.message === 'error.payment_unavailable'
        ) {
          msg = 'Оплата временно недоступна. Проверьте настройки ЮKassa (shop-id и ключ) на сервере.';
        } else if (data?.message === 'error.noamount' || e?.message === 'error.noamount') {
          msg = 'Не указана сумма к оплате. Обратитесь в поддержку.';
        }
        this.showPaymentErrorToast(msg);
      }
      this.paying = false;
    },
    async showPaymentErrorToast(msg: string) {
      const toast = await toastController.create({ message: msg, color: 'warning', duration: 5000 });
      await toast.present();
    },
    async confirmCancelRegistration() {
      const alert = await alertController.create({
        header: 'Отменить участие?',
        message: this.myReg?.paid
          ? 'Вы будете отписаны от этого события. Возврат средств за оплаченное участие выполняется администратором — обратитесь в поддержку или дождитесь обработки заявки.'
          : 'Вы будете отписаны от этого события. Записаться снова можно до начала мероприятия.',
        cssClass: 'liga-delete-event-alert',
        buttons: [
          { text: 'Нет', role: 'cancel' },
          { text: 'Да, отменить', role: 'destructive', handler: () => this.cancelRegistration() }
        ]
      });
      await alert.present();
    },
    async cancelRegistration() {
      if (!this.myReg) return;
      this.cancelling = true;
      try {
        await eventsService.cancelRegistration(this.myReg.id);
        this.myReg = null;
      } catch (e) {
        console.error(e);
      }
      this.cancelling = false;
    }
  }
});
</script>

<style scoped>
.event-detail-logo {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 12px;
  display: block;
  margin: 0 auto 16px;
}
.event-detail-title {
  font-size: 1.5rem;
  margin-bottom: 8px;
  color: var(--liga-chrome-text);
}
.event-detail-meta {
  color: var(--liga-chrome-text);
  margin-bottom: 4px;
}
.event-detail-location {
  margin-bottom: 12px;
  color: var(--liga-chrome-text);
}
.event-detail-desc-label {
  font-size: 0.9em;
  font-weight: 600;
  color: var(--liga-chrome-text);
  margin-bottom: 4px;
}
.event-detail-desc {
  white-space: pre-wrap;
  margin-bottom: 16px;
  color: var(--liga-chrome-text);
}
.event-tiers {
  margin-bottom: 16px;
  color: var(--liga-chrome-text);
}
.tiers-label {
  font-weight: 600;
  margin-bottom: 4px;
}
.qr-block {
  margin-top: 24px;
  text-align: center;
}
.qr-label {
  margin-bottom: 12px;
  font-weight: 600;
  color: var(--liga-chrome-text);
}
.qr-wrap {
  display: inline-block;
  padding: 16px;
  background: var(--liga-float-glass-bg-strong);
  border-radius: 12px;
  border: 3px solid var(--ion-color-orange, #ff6600);
}
.qr-wrap :deep(canvas) {
  display: block;
}
.reg-status {
  display: block;
  margin-bottom: 12px;
  color: var(--liga-chrome-text);
}
.offer-note {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: var(--liga-chrome-text);
}
.offer-note a {
  color: var(--ion-color-orange);
}
.event-refund-note {
  margin-top: 6px;
  font-size: 12px;
  color: var(--liga-chrome-text);
}
.event-refund-note a {
  color: var(--ion-color-orange);
}
.event-detail-float-toolbar {
  --background: transparent;
  --border-width: 0;
  --padding-top: calc(6px + env(safe-area-inset-top, 0px));
  --padding-bottom: 6px;
  --padding-start: 10px;
  --padding-end: 10px;
  --min-height: 0;
}
.event-detail ion-item {
  --background: var(--liga-surface);
  --color: var(--liga-chrome-text);
  --border-color: var(--liga-surface-border);
}
.event-phone-item {
  margin-top: 12px;
  border-radius: 12px;
  overflow: hidden;
}
.event-phone-item ion-input {
  --color: var(--liga-chrome-text);
  --placeholder-color: var(--liga-chrome-text-muted);
  --highlight-color-focused: var(--ion-color-orange, #ff6600);
}
.event-phone-note {
  display: block;
  margin: 6px 0 10px;
  font-size: 12px;
  color: var(--liga-chrome-text-muted);
}
.event-register-btn,
.event-pay-btn {
  --background: #e85d04;
  --background-activated: #dc2f02;
  --background-hover: #f07d34;
  --color: var(--liga-chrome-text);
  --color-activated: #fff;
  --color-hover: #fff;
  font-weight: 600;
  border-radius: 8px;
  margin-top: 8px;
}
.event-cancel-btn {
  --border-color: rgba(255, 193, 7, 0.8);
  --color: #ffc107;
  font-weight: 600;
  border-radius: 8px;
  margin-top: 20px;
}
.event-cancel-btn:hover,
.event-cancel-btn.ion-activated {
  --background: rgba(255, 193, 7, 0.15);
  --color: #ffc107;
}
@media (max-width: 768px) {
  .event-detail-header-actions .header-btn-label {
    display: none;
  }
}
</style>
